module.exports = __webpack_public_path__ + "static/media/asurion-protect-it-tablet-big.cf9e7f8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-protect-it-tablet-big.jpg
// module id = 1388
// module chunks = 0